import { Ref, onBeforeUnmount, onMounted, ref } from "vue"

export default function useExtraPlaceholder(outDomRef: Ref<Element>, inputClass: string) {
    const showPlaceHolder = ref(true)

    let inputDom: Element;
    const inputListener = (e) => {
        showPlaceHolder.value = !e.target.value;
    }
    const blurListener = (e) => {
        showPlaceHolder.value = true;
    }

    onMounted(() => {
        inputDom = outDomRef.value.querySelector(inputClass);
        inputDom?.addEventListener("input", inputListener)
        inputDom?.addEventListener("blur", blurListener)
    })

    onBeforeUnmount(() => {
        inputDom?.removeEventListener('input', inputListener)
        inputDom?.removeEventListener('blur', blurListener)
    })

    return { showPlaceHolder };
}